<!--
 * @Description: file content
 * @Author: yangsibo
 * @Date: 2022-06-06 09:39:33
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-06-07 14:58:46
 * @FilePath: \YunYin_admin\src\views\Cooperative\SetQuery\Log.vue
-->
<template>
  <LogList :dataSource="3" :nonDetail="false"></LogList>
</template>

<script>
import LogList from "@/components/Query/LogList";
export default {
  name: "Log",
  data() {
    return {};
  },
  components: { LogList },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>
